<h2 mat-dialog-title class="dialog_title">
    <span (click)="log()">
        {{ "Translate document" | translate }}:
    </span>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography">
    <div class="container parameters_target_wrp" [appDeviceClass]="'custom-scroll'">

        <mat-form-field appearance="legacy" class="full_width_form">
            <mat-label>{{ "AI model" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" [multiple]="false" selectDir [formControl]="ai_model">
              <mat-option>
                <ngx-mat-select-search 
                    placeholderLabel="{{ 'Search' | translate }}" 
                    noEntriesFoundLabel="{{ 'no matching model found' | translate }}"
                    [formControl]="aiModelControl"></ngx-mat-select-search>
              </mat-option>
              <ng-container *ngFor="let model of models$ | async">
                <mat-option [value]="model.id">
                    <div class="d-f-c" style="justify-content: space-between;">
                        {{model.name}}
                        <div class="d-f-c">
                            <div class="ai-icon" *ngIf="model?.is_image_input">
                                <mat-icon class="ai-main">crop_original</mat-icon>
                                <mat-icon class="ai-small top-right">expand_circle_down</mat-icon>
                            </div>
                            <div class="ai-point" *ngIf="model?.is_web_search"></div>
                        </div>
                    </div>
                </mat-option>
              </ng-container>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="standard" class="full_width_form">
            <mat-label>{{ "Target language(s)" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" [(ngModel)]="target_language">
                <mat-select-trigger class="multi_users">
                    <ng-container *ngIf="target_language && target_language.length">
                        <ng-container *ngFor="let val of target_language">
                            <span>{{ val }}</span>
                        </ng-container>
                    </ng-container>
                </mat-select-trigger>
                <mat-option>
                    <ngx-mat-select-search 
                    placeholderLabel="{{ 'Search' | translate }}" 
                    noEntriesFoundLabel="{{ 'no matching language found' | translate }}"
                    [formControl]="langsControl"></ngx-mat-select-search>
                </mat-option>
                <mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
                    (change)="toggleSelection($event)">
                    {{'Select All' | translate}}
                </mat-checkbox>
                <ng-container *ngFor="let item of langs$ | async">
                    <mat-option [value]="item.value">
                        <span>{{ item.value }}</span>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="btns">
        <button mat-raised-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="save()" mat-raised-button cdkFocusInitial color="primary" [disabled]="!target_language.length || isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Save" | translate }}
        </button>
    </div>
</mat-dialog-actions>